import React from 'react';
import { Card } from '../../design-system';

export const DevOverview: React.FC = () => {
  return (
    <>
      <h1 className="dev-portal__title">Build on BigSystemOne</h1>
      <p className="dev-portal__lede">
        The BSO Public API lets you integrate ordering, inventory, menu,
        equipment, and analytics events directly into your own systems.
      </p>

      <div className="dev-portal__grid">
        <Card>
          <Card.Body>
            <Card.Title>1. Read the reference</Card.Title>
            <p className="dev-portal__muted" style={{ margin: '8px 0 0' }}>
              Every endpoint, schema, and error code is documented in the{' '}
              <a href="/developers/docs">API reference</a>. The same spec is
              downloadable as OpenAPI 3.1 YAML from{' '}
              <code>/public-api/openapi.yaml</code>.
            </p>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            <Card.Title>2. Provision a key</Card.Title>
            <p className="dev-portal__muted" style={{ margin: '8px 0 0' }}>
              Create a sandbox API key from the{' '}
              <a href="/developers/keys">API keys</a> page. Sandbox keys hit an
              isolated dataset and are prefixed <code>bso_sand_</code>.
            </p>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            <Card.Title>3. Subscribe to events</Card.Title>
            <p className="dev-portal__muted" style={{ margin: '8px 0 0' }}>
              Register a webhook endpoint on the{' '}
              <a href="/developers/webhooks">Webhooks</a> page and verify
              deliveries with the supplied HMAC signing secret.
            </p>
          </Card.Body>
        </Card>
      </div>

      <section className="dev-portal__section">
        <h2 className="dev-portal__section-title">Base URLs</h2>
        <pre className="dev-portal__code">{`# Production
https://api.bigsystemone.com/v1

# Sandbox (isolated dataset)
https://sandbox.api.bigsystemone.com/v1`}</pre>
      </section>

      <section className="dev-portal__section">
        <h2 className="dev-portal__section-title">First request</h2>
        <pre className="dev-portal__code">{`curl https://sandbox.api.bigsystemone.com/v1/stores \\
  -H "Authorization: Bearer bso_sand_<your-key>"`}</pre>
      </section>
    </>
  );
};
